/* === Sección "New Collection" (slider de productos + 1er slide estático) === */
(function () {
  function initNewCollectionSliders() {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('.js-new-collection-swiper').forEach(function (elem) {
      if (elem.dataset.swiperInit === 'true') return; // evitar doble init
      var mobileLayout = parseInt(elem.dataset.mobileLayout, 10) || 1;
      // La navegación vive en la cabecera de la sección (fuera del contenedor del slider),
      // así que la buscamos a nivel de sección, no dentro de `elem`.
      var section = elem.closest('.new-collection') || document;
      new Swiper(elem, {
        slidesPerView: mobileLayout,
        slidesPerGroup: 1,
        spaceBetween: 8,
        speed: 600,
        watchOverflow: true,
        navigation: {
          nextEl: section.querySelector('.new-collection__nav .swiper-button-next'),
          prevEl: section.querySelector('.new-collection__nav .swiper-button-prev'),
        },
        breakpoints: {
          576: { slidesPerView: 2, slidesPerGroup: 2 },
          750: { slidesPerView: 3, slidesPerGroup: 3 },
          1200: { slidesPerView: 4, slidesPerGroup: 4 },
        },
      });
      elem.dataset.swiperInit = 'true';
    });
  }

  if (document.readyState !== 'loading') {
    initNewCollectionSliders();
  } else {
    document.addEventListener('DOMContentLoaded', initNewCollectionSliders);
  }
  // Re-init al cargar la sección en el editor de temas
  document.addEventListener('shopify:section:load', initNewCollectionSliders);
  // Re-init al cargar la sección en el editor de temas
  document.addEventListener('shopify:section:load', initNewCollectionSliders);
})();
